/**
 * 恒星管控名单（2026-10-10 新增）
 *
 * 作用：这里列出的恒星属于「恒星管控」范围，行为口径固定为：
 *   1. **恒参与后端请求**：不论用户在恒星配置里怎么点（选中/取消/全选），
 *      这些 starNum 都会并入星盘请求的 selectedStars（见 utils/starControl.js）；
 *   2. **默认不上画布**：参与计算与点/面报警判定，但画布默认不绘制
 *      （报警闪烁重绘同样经 filterCanvasVisibleStars 过滤，不会把它们暴露出来）；
 *   3. **恒星按钮默认屏蔽**：用户需开通「恒星管控」权限后，配置弹窗才会展示这些按钮。
 *
 * 维护说明（重要）：
 *   - **不需要管控某颗星时，直接把它整条注释掉即可**；注释掉的条目不会被读取使用；
 *   - 条目数量不固定，可增可减；
 *   - `starNum` 必须与星盘后端 `indexMapInfo.yml` 的 `starInfo.starNum` 一致
 *     （星表里不存在该编号时会被星盘端直接忽略，不会报错）。
 *
 * 本模块为纯数据（CommonJS），不依赖 window / axios / Vue，便于 node 直跑断言。
 */

module.exports = [
  { starNum: 3, starName: '土司空', starIndexName: 'Diphda', alarmType: 'ALARM_RED', alarmColor: '#FF0000' },
  { starNum: 9, starName: '天仓四', starIndexName: 'Baten Kaitos', alarmType: 'ALARM_RED', alarmColor: '#FF0000' },
  { starNum: 12, starName: '奎宿增廿一', starIndexName: 'Vertex-S', alarmType: 'ALARM_RED', alarmColor: '#FF0000' },
  { starNum: 32, starName: '大陵五', starIndexName: 'Algol', alarmType: 'ALARM_RED', alarmColor: '#FF0000' },
  // 该条在 indexMapInfo.yml 中原本就是注释状态；先按「17 个」纳入，若星表无此编号可保持注释
  { starNum: 33, starName: '昂宿星团', starIndexName: 'Pleadies', alarmType: 'ALARM_RED', alarmColor: '#FF0000' },
  { starNum: 34, starName: '昴宿六（团）', starIndexName: 'Alcyone', alarmType: 'ALARM_RED', alarmColor: '#FF0000' },
  { starNum: 42, starName: '参宿五', starIndexName: 'Bellatrix', alarmType: 'ALARM_RED', alarmColor: '#FF0000' },
  { starNum: 68, starName: '北河三', starIndexName: 'Pollux', alarmType: 'ALARM_RED', alarmColor: '#FF0000' },
  { starNum: 78, starName: '积尸气（鬼团）', starIndexName: 'Praesepe Cluster', alarmType: 'ALARM_RED', alarmColor: '#FF0000' },
  { starNum: 79, starName: '鬼宿三', starIndexName: 'Asellus Borealis', alarmType: 'ALARM_RED', alarmColor: '#FF0000' },
  { starNum: 82, starName: '北极二', starIndexName: 'Kochab', alarmType: 'ALARM_RED', alarmColor: '#FF0000' },
  { starNum: 85, starName: '轩辕八', starIndexName: 'Alterf', alarmType: 'ALARM_RED', alarmColor: '#FF0000' },
  { starNum: 87, starName: '轩辕九', starIndexName: 'Ras Elased Australis', alarmType: 'ALARM_RED', alarmColor: '#FF0000' },
  { starNum: 142, starName: '氐宿增七（一）', starIndexName: 'Zubenelgenubi', alarmType: 'ALARM_RED', alarmColor: '#FF0000' },
  { starNum: 145, starName: '天市右垣七', starIndexName: 'Unukalhai', alarmType: 'ALARM_RED', alarmColor: '#FF0000' },
  { starNum: 162, starName: '尾宿九', starIndexName: 'Lesath', alarmType: 'ALARM_RED', alarmColor: '#FF0000' },
  { starNum: 218, starName: '室宿二', starIndexName: 'Scheat', alarmType: 'ALARM_RED', alarmColor: '#FF0000' }
]
